import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

const handleReload = (): void => {
  window.location.reload();
};

export const RouteErrorFallback = memo((): React.ReactElement => {
  const { t } = useTranslation("common");

  return (
    <div
      className="h-full flex flex-col items-center justify-center gap-3 text-center p-5"
      data-testid="route-error-fallback"
    >
      <div className="text-lg font-semibold">{t("something_went_wrong")}</div>
      <Button variant="outline" onClick={handleReload}>
        {t("reload_page")}
      </Button>
    </div>
  );
});
